// @flow
import * as React from 'react';
import { imageUrl } from 'utils/filestack';
import Text, { H2, HeadingSmall } from 'components/Text';
import Box from 'components/Box';
import type { CtaHeroBlockData } from 'api/cms';
import { PrimaryButtonLink, CallToActionButton } from 'components/Button';
import { gutterWidth } from '../../../theme';

const getImageUrl = (handle: string) =>
  imageUrl({
    handle,
    transform: `resize=width:2096,fit:max/quality=value:70`
  });

type Data = CtaHeroBlockData & {
  isGrad?: boolean,
  isEmailSignup?: boolean,
  isMap?: boolean,
  label?: string
};

const HeroBlock = ({
  data: {
    label,
    buttonText,
    buttonUrl,
    text,
    image,
    isGrad,
    isEmailSignup,
    isMap
  },
  loggedIn,
  hasGradProgram,
  pageUrl,
  blockId
}: {
  data: Data,
  loggedIn: boolean,
  hasGradProgram: boolean,
  pageUrl: string,
  blockId: string
}) => (
  <Box
    height={450}
    mx={[-gutterWidth / 2, null, -gutterWidth]}
    overflow="hidden"
    color="white"
    textAlign="center"
    borderRadius={[0, null, null, 48]}
    backgroundImage={`url(${
      image && image.handle
        ? getImageUrl(image.handle)
        : isMap
        ? '/static/images/idealist-days-map.jpg'
        : isEmailSignup
        ? '/static/images/blue-loops.svg'
        : '/static/images/blue-loops.svg'
    })`}
    backgroundSize="cover"
  >
    <Box
      width={1}
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bg="rgba(0,0,0,0.35)"
      textAlign="center"
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        {label && <HeadingSmall>{label}</HeadingSmall>}
        {isMap ? (
          <Text dangerouslySetInnerHTML={{ __html: text }} />
        ) : (
          <H2>{text}</H2>
        )}
      </Box>
      {buttonUrl && buttonText ? (
        <PrimaryButtonLink href={buttonUrl}>{buttonText}</PrimaryButtonLink>
      ) : isGrad ? (
        <CallToActionButton
          loggedIn={loggedIn}
          hasGradProgram={hasGradProgram}
        />
      ) : (
        buttonText && (
          <PrimaryButtonLink href={`/${pageUrl}#cms-block-${blockId}`}>
            {buttonText}
          </PrimaryButtonLink>
        )
      )}
    </Box>
  </Box>
);

export default HeroBlock;
